// extracted by mini-css-extract-plugin
export default {"header":"Header_header__S8KfQ","logo":"Header_logo__25Nc0","image":"Header_image__MxDXO","title":"Header_title__Xh1O9","subtitle":"Header_subtitle__7rjzR"};